import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SignOutIcon = ({ color = '#fff', size = 15, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 25 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill={color} fillRule="nonzero">
      <path d="M24.375 17.5H21.25V4.432c0-1.065-.841-1.932-1.875-1.932H15V5h3.75v15h5.625c.345 0 .625-.28.625-.625v-1.25a.625.625 0 0 0-.625-.625zM12.197.04l-7.5 1.942A1.287 1.287 0 0 0 3.75 3.24V17.5H.625a.625.625 0 0 0-.625.625v1.25c0 .345.28.625.625.625H13.75V1.296c0-.843-.764-1.461-1.553-1.257z" />
      <path d="M10.313 11.25c-.518 0-.938-.56-.938-1.25s.42-1.25.938-1.25c.517 0 .937.56.937 1.25s-.42 1.25-.937 1.25z" />
    </g>
  </svg>
);

SignOutIcon.propTypes = propTypes;

export default SignOutIcon;
